import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SaveGameEvent from "../events/SaveGameEvent";

export default class GameSavedNoticeMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, languagePack) {
        super(target, dispatcher);

        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();
        this._target.y -= GameSavedNoticeMediator.OFFSET_Y;
        this._target.textField.text = this._languagePack.getText(`saving.gameSavedNotice`);
    }

    displaySaveGame() {
        this.show(500, true)
            .then(() => {
                this.hide(5000, false);
            });
    }

    show(delay = 0) {
        return new Promise(resolve => {
            let aimedY = this._target.y + GameSavedNoticeMediator.OFFSET_Y;
            createjs.Tween.get(this._target)
                .wait(delay)
                .to({ y: aimedY }, 1000, createjs.Ease.sineInOut)
                .call(() => {
                    resolve();
                });
        })
    }

    hide(delay = 0) {
        return new Promise(resolve => {
            let aimedY = this._target.y - GameSavedNoticeMediator.OFFSET_Y;
            createjs.Tween.get(this._target)
                .wait(delay)
                .to({ y: aimedY }, 1000, createjs.Ease.sineInOut)
                .call(() => {
                    resolve();
                });
        })
    }
}
GameSavedNoticeMediator.OFFSET_Y = 100;